import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_nguonkinhphi, Lists_tinhchatnguonkp } from '../../../routes/menu'
import { Global, BaoCao } from '../../../shared/global';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-thamsobc-giayrutvondautu16b1edit',
  templateUrl: './giayrutvondautu16b1edit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./giayrutvondautu16b1edit.component.scss'],
  providers: [ListService, Repository]
})


export class giayrutvondautu16b1editComponent implements OnInit {

  msg: string;
  public ngayghitang: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any
  modalTitle: any;
  indLoading: boolean = false;
  doituongSelect1: any = {
    Id: null, MaDonVi: null, TenDonVi: null, DonViId: null, KTT_UserName: null
    , KTT_Password: null, CTK_UserName: null, CTK_Password: null
    , MaCapNS: null, SoTaiKhoanMoTaiKBNN: null, MaKBNN: null, dm_hs_ksc_id: null, TenVietTat: null
    , v_ma_ho_so: null, v_ma_ho_so_chi_tiet_mau: null, v_tieu_de: null
    , v_tg_ky_so_ktt: null, v_tg_ky_so_ctk: null, Phan_He_Id: null, LoaiMau: null
    , NguoiKy: null, v_tg_gui_dvc: null
    , NguoiKy_KTT: null, NguoiKy_CTK: null, v_du_lieu_toan_van: null
    , v_du_lieu_xac_thuc: null, v_chu_ky_so_ktt: null, v_chu_ky_so_ctk: null, body: null
    , Cer_ktt: null, Cer_ctk: null, hash_file: null
    , LoaiKy: null, Tich_HienChiTietCacButToan: null, Tich_TenTieuMucLaDienGiai: null
    , DoiTuong: null, Tich_HienThiTungDongChiTiet: null
    , GuiKeToanTruong: null, GuiThuTruong: null, ThongTinBoSung: null, ThamSo: null, TaiKhoan: null
  };

  doituongSelect: any = {
    Id: null, SoCKCHDK: null, SoCKCHDTH: null, PhatHanhSec: null, ThongTinBoSung: null
    , NoTK1: null, CoTK1: null, NoTK2: null, CoTK2: null, NoTK3: null, CoTK3: null
    , MaDBHC: null, DonViId: null, NoiDungThanhToan: null
    , Tich_PhatHanhSec: null, Tich_ThongTinBoSung: null
    , TenDonVi: null, MaSoThue: null, MaNDKT: null, MaChuong: null
    , CoQuanQuanLyThu: null, MaCQThu: null, KyThue: null, KBNNHachToanKhoanThu: null
    , KBNNHachToanKhoanThu_Ma: null
    , ThanhToans: []
    , NoTK4: null, CoTK4: null, NoTK5: null, CoTK5: null, NoTK6: null, CoTK6: null
    , MaDBHC2: null, MaCQThu2: null, Tich_HienChiTietCacButToan: null
    , CanCu_So: null, CanCu_Ngay: null, NamKHV: null
    , SoToKhai: null, MaDinhDanhHoSo: null, CoQuanQuanLyThu_STK: null
    , Tich_UngTruocChuaDuDieuKienThanhToan: null, Tich_UngTruocDuDieuKienThanhToan: null
  };
  nhomdtid: string = null;
  hoatdong: string = null;
  tabselected: number = 1;
  sobanghi: number;
  CanCu_Ngay: Date = null;

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('modaltuychinhmaubc', { static: false }) modaltuychinhmaubc: ModalComponent;
  @ViewChild('dtsuamaubaocao', { static: false }) dtsuamaubaocao: any;
  @Output() save: EventEmitter<any> = new EventEmitter();

  

  constructor(private _dataService: ListService, private repo: Repository) {


  }

  ngOnInit(): void {

  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  currentUser: any;

  loadDataInit(idchungtu: any, donviid: string, loaigiaydenghi: any) {
    this.ngayghitang = null;
    // loaigiaydenghi =0 hoac null: là mẫu giấy rút 16b1
    // loaigiaydenghi=1 là giấy đề nghị thanh toán vốn đầu tư 05/TT

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.id === idchungtu.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        this.modalTitle = giatri[0].ten_Phan_He;
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }

    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);
   
    this.doituongSelect = {
      Id: null, SoCKCHDK: null, SoCKCHDTH: null, PhatHanhSec: null, ThongTinBoSung: null
      , NoTK1: null, CoTK1: null, NoTK2: null, CoTK2: null, NoTK3: null, CoTK3: null
      , MaDBHC: null, DonViId: null, NoiDungThanhToan: null
      , Tich_PhatHanhSec: null, Tich_ThongTinBoSung: null
      , TenDonVi: null, MaSoThue: null, MaNDKT: null, MaChuong: null
      , CoQuanQuanLyThu: null, MaCQThu: null, KyThue: null, KBNNHachToanKhoanThu: null
      , KBNNHachToanKhoanThu_Ma: null
      , ThanhToans: []
      , NoTK4: null, CoTK4: null, NoTK5: null, CoTK5: null, NoTK6: null, CoTK6: null
      , MaDBHC2: null, MaCQThu2: null, Tich_HienChiTietCacButToan: null
      , CanCu_So: null, CanCu_Ngay: null, NamKHV: null, LoaiGiayDeNghi: loaigiaydenghi
      , SoToKhai: null, MaDinhDanhHoSo: null, CoQuanQuanLyThu_STK: null
      , Tich_UngTruocChuaDuDieuKienThanhToan: null, Tich_UngTruocDuDieuKienThanhToan: null
    };
    this.repo.getRequest("api/doituong/ThongTinRutDuToan02b/" + idchungtu)
      .subscribe(response => {
        this.doituongSelect.ThanhToans = response;
        console.log(this.doituongSelect.ThanhToans);
      });
    this.doituongSelect.Id = idchungtu;
    this.doituongSelect.Tich_PhatHanhSec = false;
    this.doituongSelect.PhatHanhSec = 'Yêu cầu phát hành sec cho';
    this.doituongSelect.Tich_ThongTinBoSung = false;
    this.doituongSelect.Tich_HienChiTietCacButToan = true;
    this.doituongSelect.Tich_UngTruocChuaDuDieuKienThanhToan = false;
    this.doituongSelect.Tich_UngTruocDuDieuKienThanhToan = false;
    this.doituongSelect.DonViId = donviid;


    this.repo.getRequest('api/donvicauhinh/thietlapthamso/' + donviid)
      .subscribe(response => {
        this.doituongSelect.TenDonVi = response.RDT16A2_TenDonVi;
        this.doituongSelect.MaSoThue = response.RDT16A2_MST;
        this.doituongSelect.MaNDKT = response.RDT16A2_NDKT;
        this.doituongSelect.MaChuong = response.RDT16A2_Chuong;
        this.doituongSelect.CoQuanQuanLyThu = response.RDT16A2_CoQuanQuanLyThu;
        this.doituongSelect.MaCQThu = response.RDT16A2_MaCQThu;
        this.doituongSelect.KyThue = response.RDT16A2_KyThue;
        this.doituongSelect.KBNNHachToanKhoanThu = response.RDT16A2_KBNN_HachToan;
        this.doituongSelect.KBNNHachToanKhoanThu_Ma = response.RDT16A2_KBNN_HachToan_Ma;




        this.doituongSelect1.Id = idchungtu;
        this.doituongSelect1.DonViId = donviid;
        this.doituongSelect1.LoaiMau = 16;
        this.repo.postRequest("api/dvcapi/getbyid_dvc_thamso", this.doituongSelect1)
          .subscribe(response => {
            if (response != null && response.ThamSo != null && response.ThamSo != "") {
              let data = JSON.parse(response.ThamSo);
              //this.doituongSelect = data;

              this.doituongSelect.Id = data.Id;
              this.doituongSelect.SoCKCHDK = data.SoCKCHDK;
              this.doituongSelect.SoCKCHDTH = data.SoCKCHDTH;
              this.doituongSelect.PhatHanhSec = data.PhatHanhSec;
              this.doituongSelect.ThongTinBoSung = data.ThongTinBoSung;
              this.doituongSelect.NoTK1 = data.NoTK1;
              this.doituongSelect.CoTK1 = data.CoTK1;
              this.doituongSelect.NoTK2 = data.NoTK2;
              this.doituongSelect.CoTK2 = data.CoTK2;
              this.doituongSelect.NoTK3 = data.NoTK3;
              this.doituongSelect.CoTK3 = data.CoTK3;
              this.doituongSelect.MaDBHC = data.MaDBHC;
              this.doituongSelect.DonViId = data.DonViId;
              this.doituongSelect.NoiDungThanhToan = data.NoiDungThanhToan;
              this.doituongSelect.Tich_PhatHanhSec = data.Tich_PhatHanhSec;
              this.doituongSelect.Tich_ThongTinBoSung = data.Tich_ThongTinBoSung;
              this.doituongSelect.SoToKhai = data.SoToKhai;
              this.doituongSelect.TenDonVi = data.TenDonVi;
              this.doituongSelect.MaSoThue = data.MaSoThue;
              this.doituongSelect.MaNDKT = data.MaNDKT;
              this.doituongSelect.MaChuong = data.MaChuong;
              this.doituongSelect.CoQuanQuanLyThu = data.CoQuanQuanLyThu;
              this.doituongSelect.MaCQThu = data.MaCQThu;
              this.doituongSelect.KyThue = data.KyThue;
              this.doituongSelect.KBNNHachToanKhoanThu = data.KBNNHachToanKhoanThu;
              //this.doituongSelect.ThanhToans = data.ThanhToans;
              this.doituongSelect.NoTK4 = data.NoTK4;
              this.doituongSelect.CoTK4 = data.CoTK4;
              this.doituongSelect.NoTK5 = data.NoTK5;
              this.doituongSelect.CoTK5 = data.CoTK5;
              this.doituongSelect.NoTK6 = data.NoTK6;
              this.doituongSelect.CoTK6 = data.CoTK6;
              this.doituongSelect.MaDBHC2 = data.MaDBHC2;
              this.doituongSelect.MaCQThu2 = data.MaCQThu2;
              this.doituongSelect.Tich_HienChiTietCacButToan = data.Tich_HienChiTietCacButToan;
              this.doituongSelect.KBNNHachToanKhoanThu_Ma = data.KBNNHachToanKhoanThu_Ma;
              this.doituongSelect.CanCu_So = data.CanCu_So;
              this.doituongSelect.NamKHV = data.NamKHV;
              this.doituongSelect.SoToKhai = data.SoToKhai;
              this.doituongSelect.MaDinhDanhHoSo = data.MaDinhDanhHoSo;
              this.doituongSelect.CoQuanQuanLyThu_STK = data.CoQuanQuanLyThu_STK;
              if (response.CanCu_Ngay != null)
                this.ngayghitang = new Date(response.CanCu_Ngay);

              this.doituongSelect.Tich_UngTruocChuaDuDieuKienThanhToan = data.Tich_UngTruocChuaDuDieuKienThanhToan;
              this.doituongSelect.Tich_UngTruocDuDieuKienThanhToan = data.Tich_UngTruocDuDieuKienThanhToan;
              
              

            }

            this.doituongSelect1.v_ma_ho_so = response.v_ma_ho_so;
            this.doituongSelect1.v_tieu_de = response.v_tieu_de;

          });



      });




  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  //public saveproduct() {

  //  this.repo.postRequest("api/doituong/addorupdate", this.doituongSelect)
  //    .subscribe(response => {
  //      console.log(response);
  //      this.doituongSelect.Id = response;
  //      this.save.emit(this.doituongSelect);
  //    });

  //}
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };
  itemrow: any;
  public changerange(row: any) {
    if (this.doituongSelect.ThanhToans != null) {
      for (let i: number = 0; i < this.doituongSelect.ThanhToans.length; i = i + 1) {
        this.itemrow = this.doituongSelect.ThanhToans[i];
        if (this.itemrow.IDCHUNGTU == row.IDCHUNGTU && row.NOPTHUE != null && this.itemrow.SOTIENDK!=null) {
            this.doituongSelect.ThanhToans[i].DONVIHUONG = this.doituongSelect.ThanhToans[i].SOTIENDK - this.doituongSelect.ThanhToans[i].NOPTHUE;
        }
      }
    }
  }
  public tuychinhmaubaocao() {
    if (this.doituongSelect.LoaiGiayDeNghi == null || this.doituongSelect.LoaiGiayDeNghi == 0) {
      this.dtsuamaubaocao.loadDataInit(BaoCao.BC07_02_GiayRutDuToan_16b1);
      this.modaltuychinhmaubc.open();
    }
    if (this.doituongSelect.LoaiGiayDeNghi == 1) {
      this.dtsuamaubaocao.loadDataInit(BaoCao.BC07_02_GiayRutDuToan_16b1_05TT);
      this.modaltuychinhmaubc.open();
    }
    if (this.doituongSelect.LoaiGiayDeNghi == 2) {
      this.dtsuamaubaocao.loadDataInit("FBDCB889-020B-4B04-9CBE-82F50D473DD2");
      this.modaltuychinhmaubc.open();
    }
  }
  public export(kieuin) {

    if (this.ngayghitang != null)
      this.doituongSelect.CanCu_Ngay = this.ngayghitang.getDate() + '/' + (this.ngayghitang.getMonth() + 1) + '/' + this.ngayghitang.getFullYear();

    this.doituongSelect1.DoiTuong = JSON.stringify(this.doituongSelect);

    this.repo.postRequest("api/dvcapi/addorupdate_thamso", this.doituongSelect1)
      .subscribe(response => {
        // lưu tham số
      });

    let idbaocao = null;
    if (this.doituongSelect.LoaiGiayDeNghi == null || this.doituongSelect.LoaiGiayDeNghi == 0) {
      idbaocao = BaoCao.BC07_02_GiayRutDuToan_16b1;
    }
    if (this.doituongSelect.LoaiGiayDeNghi == 1) {
      idbaocao = BaoCao.BC07_02_GiayRutDuToan_16b1_05TT;
    }
    if (this.doituongSelect.LoaiGiayDeNghi == 2) {
      idbaocao = "FBDCB889-020B-4B04-9CBE-82F50D473DD2"; // 05.a/TT Nghị định 254
    }
    
    $('#loading').show();
    let data = {
      Id: BaoCao.BC07_02_GiayRutDuToan_16b1, // id cứng trong FunctionConstants để điều hướng đến hàm giay rút dự toán
      Type: kieuin,
      Data: JSON.stringify(this.doituongSelect)
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          $('#loading').hide();
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "giayrutvondautu.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            $('#loading').hide();
            //this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
            //  data => {
            //    $('#loading').hide();
            //  },
            //  error => {
            //    this.msg = error;
            //  }
            //);
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }
    


  }


  export_xml(loaiphieu) {
    //loaiphieu=1 giấy rút mẫu 02
    //loaiphieu=2 giấy rút mẫu 02b
    //loaiphieu=3 Bảng kê chứng từ thanh toán tạm ứng
    //loaiphieu=4 giấy đề nghị thanh toán tạm ứng
    if (this.ngayghitang != null)
      this.doituongSelect.CanCu_Ngay = this.ngayghitang.getDate() + '/' + (this.ngayghitang.getMonth() + 1) + '/' + this.ngayghitang.getFullYear();


    
    $('#loading').show();
    let datatt = {
      Id: null,
      Type: null,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , IdChungTu: this.doituongSelect.Id
        , LoaiPhieu: loaiphieu
        , Tich_HienChiTietCacButToan: this.doituongSelect.Tich_HienChiTietCacButToan
        , CanCu_Ngay: this.doituongSelect.CanCu_Ngay
        , CanCu_So: this.doituongSelect.CanCu_So
        , NamKHV: this.doituongSelect.NamKHV
        , LoaiGiayDeNghi: this.doituongSelect.LoaiGiayDeNghi
        , TenDonVi: this.doituongSelect.TenDonVi
        , MaSoThue: this.doituongSelect.MaSoThue
        , MaNDKT: this.doituongSelect.MaNDKT
        , MaChuong: this.doituongSelect.MaChuong
        , CoQuanQuanLyThu: this.doituongSelect.CoQuanQuanLyThu
        , MaCQThu: this.doituongSelect.MaCQThu
        , KyThue: this.doituongSelect.KyThue
        , KBNNHachToanKhoanThu: this.doituongSelect.KBNNHachToanKhoanThu
        , SoToKhai: this.doituongSelect.SoToKhai
        , MaDinhDanhHoSo: this.doituongSelect.MaDinhDanhHoSo
        , CoQuanQuanLyThu_STK: this.doituongSelect.CoQuanQuanLyThu_STK
        , Tich_UngTruocChuaDuDieuKienThanhToan: this.doituongSelect.Tich_UngTruocChuaDuDieuKienThanhToan
        , Tich_UngTruocDuDieuKienThanhToan: this.doituongSelect.Tich_UngTruocDuDieuKienThanhToan

      })
    };


    this.repo.postRequest("api/baocao/ketnoikbnn/", datatt)
      .subscribe(response => {
        $('#loading').hide();
        if (response.TrangThai = "OK") {
          location.href = "/Logs/Reports/" + response.DuongDan;
        }
        else
          swal('Cảnh báo!', response.TrangThai, 'warning');
      });



  }




}
